import React from 'react';

import styles from './feedItemStyles';

const feedItemEmpty = ({ children }) => <div className={styles.feedItem}>{children}</div>;

export default feedItemEmpty;
